function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.11 56.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M.43,2.78c-.38,1.51-.16,7.02.49,12.25,1.51,12.18,1.48,18.6-.12,24.1-1.55,5.34-.76,13.29,1.53,15.59,1.04,1.04,3.09,1.61,5.45,1.51,2.08-.08,6.53-.17,9.89-.18,5.54-.03,6.2-.26,7.25-2.57,2.1-4.61,1.38-11.47-1.94-18.44-1.7-3.57-4.41-9.79-6.01-13.81C13.35,12.17,9.34,4.1,7.31,1.8,4.87-.98,1.24-.46.43,2.78",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7,4.6c.92,1.4,4.06,8.26,6.99,15.25l5.32,12.7-5.92.59c-3.26.33-6.58,1.14-7.38,1.8-1.24,1.03-1.37.62-.92-2.76.29-2.18-.25-9.16-1.21-15.51C1.88,5.41,1.98,2.05,4.03,2.05c.55,0,1.76,1.15,2.68,2.55",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.35,36.46c2.89,2.89,4.08,7.53,3.13,12.25l-.9,4.52-8.76.31c-7.99.29-8.89.13-10.25-1.82-1.97-2.81-1.9-8.66.14-11.56,3.16-4.51,13.53-6.82,16.64-3.71",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18);
export default __webpack_public_path__ + "static/media/18.978d3d7b2abe0b64258ef56702573e20.svg";
export { ForwardRef as ReactComponent };